(function(){
     var mySwiper = new Swiper ('.swiper', {
        // direction: 'vertical', // 垂直切换选项
        // autoplay: true,
        setWrapperSize :true,
        roundLengths : true, 
        watchOverflow: true,
        rewind: false,
        slideNextClass : 'my-slide-Next',
        slidePrevClass : 'my-slide-Prev',
        slidesPerView : 1,
        slidesPerGroup : 1,
        spaceBetween: 30,
        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
          disabledClass: 'my-swiper-disabled',
        }
  })        
})()